var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1 8.24H7.43C7.86 8.24 8.23 8.54 8.31 8.96C8.73 10.92 10.66 12.18 12.62 11.76C14.02 11.46 15.12 10.36 15.42 8.96C15.5 8.54 15.87 8.23 16.3 8.24H22.73V2.81C22.73 1.81 21.92 1 20.92 1H2.81C1.81 1 1 1.81 1 2.81V8.24Z",
    fill: "#91BC68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.81 1H20.92C21.92 1 22.73 1.81 22.73 2.81V15.49C22.73 16.49 21.92 17.3 20.92 17.3H2.81C1.81 17.3 1 16.49 1 15.49V2.81C1 1.81 1.81 1 2.81 1Z",
    stroke: "#74B743",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 8.23998H7.43C7.86 8.23998 8.23 8.53998 8.31 8.95998C8.73 10.92 10.66 12.18 12.62 11.76C14.02 11.46 15.12 10.36 15.42 8.95998C15.5 8.53998 15.87 8.22998 16.3 8.23998H22.73",
    stroke: "#74B743",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.62012H22.73",
    stroke: "#74B743",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountNumber);
export default __webpack_public_path__ + "static/media/accountNumber.3e25fa0b46fd132c443e4a24904af141.svg";
export { ForwardRef as ReactComponent };